import React from "react";
import { ReactComponent as BeeBetter } from "../resources/images/bee_Better_Logo.svg";
import SvgIcon from "@mui/material/SvgIcon";

const BeeBetterIcon = () => {
  return <SvgIcon component={BeeBetter} inheritViewBox />;
};

export { BeeBetterIcon };
